/**
 * Consent checkbox copy for the setup / terms step.
 *
 * Single source of truth shared by the WordPress plugin setup wizard
 * (miles-plugin TermsStep) and the cloud dashboard (TermsPage). Plain data
 * only — each surface renders its own JSX/link element and owns its own submit
 * logic, so the shared piece is just the copy, the linked documents, and the
 * option list/order.
 */
/** Streamed heading + subtitle shown above the consent checkboxes. */
export const TERMS_TITLE_LINE_1 = 'Hey, looking forward to working with you.';
export const TERMS_TITLE_LINE_2 = 'Before we can get started, the legal bits.';
export const TERMS_SUBTITLE = 'Please review and accept the following:';

export interface TermsOption {
  /** Stable id; also the key used to track which boxes are checked. */
  id: string;
  /** Linked document title, e.g. "Terms of Service". Omit for a link-less item. */
  linkText?: string;
  /** URL the linkText points to. */
  url?: string;
  /** Copy rendered before the link. */
  textBefore: string;
  /** Copy rendered after the link. */
  textAfter: string;
}

export const TERMS_OPTIONS: TermsOption[] = [
  {
    id: 'tos',
    linkText: 'Terms of Service',
    url: 'https://bymiles.ai/terms',
    textBefore: 'I agree to the ',
    textAfter: '.',
  },
  {
    id: 'privacy',
    linkText: 'Privacy Policy',
    url: 'https://bymiles.ai/privacy',
    textBefore: 'I agree to the ',
    textAfter:
      ' and understand Miles connects to our servers to process your requests.',
  },
  {
    id: 'ai',
    linkText: 'AI Disclaimer',
    url: 'https://bymiles.ai/ai-disclaimer/',
    textBefore: 'I agree to the ',
    textAfter:
      ' and understand Miles is AI and can make mistakes. I have a recent site backup and will keep regular backups when using Miles.',
  },
];
